import PageHeader from "../components/PageHeader";
import { Award, Crown, Compass, ShieldCheck, Headphones, TrendingUp } from "lucide-react";

const REASONS = [
  { icon: Crown, title: "Hotel-grade Hospitality", text: "We staff like a five-star hotel. Senior account managers, vetted housekeepers, and a 24/7 concierge desk that never sleeps." },
  { icon: TrendingUp, title: "High Occupancy Strategy", text: "Yield management driven by London market data. Our owners average 92% occupancy and a 38% revenue uplift in year one." },
  { icon: Headphones, title: "Premium Customer Service", text: "Dedicated account director, owner portal, transparent reporting and a single point of contact for every property." },
  { icon: ShieldCheck, title: "Stress-free Management", text: "End-to-end operations: cleaning, maintenance, listings, marketing, guest screening, financial reconciliation." },
  { icon: Award, title: "12+ Years in London", text: "We know the postcodes, the planning officers, the cleaners worth retaining and the price points that actually work." },
  { icon: Compass, title: "Curated, Not Volume", text: "We are deliberately small. Our portfolio is hand-picked, our team is hand-trained, and our standards are uncompromising." },
];

export default function WhyChooseUs() {
  return (
    <div data-testid="why-page" className="bg-[#050505] text-white -mb-24">
      <PageHeader
        overline="Why Choose Us"
        title="The studio London's most discerning owners trust."
        subtitle="Six reasons our owners stay with us for years — and our guests come back for life."
        image="https://images.unsplash.com/photo-1767713421795-ca09a9d05c38?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      />

      <section className="py-20">
        <div className="container mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {REASONS.map((r, i) => (
              <div key={i} data-testid={`reason-card-${i}`} className="card-flat p-8">
                <div className="w-12 h-12 border border-gold/40 flex items-center justify-center mb-6 text-gold">
                  <r.icon size={20} />
                </div>
                <h3 className="font-serif text-2xl text-white mb-3">{r.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed">{r.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#0a0d0b]">
        <div className="container mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <div>
            <p className="overline mb-5">A Promise</p>
            <h2 className="font-serif text-4xl sm:text-5xl text-white leading-tight mb-6">
              "If we're not the best decision you make this year, we'll refund our first quarter's fee."
            </h2>
            <p className="text-white/60">— Founder, West London Stays</p>
          </div>
          <div className="image-zoom aspect-[4/5]">
            <img src="https://images.unsplash.com/photo-1761437855598-011cf89b2ad4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="" className="w-full h-full object-cover" />
          </div>
        </div>
      </section>
    </div>
  );
}
